/** Pass template builder tab labels — single source of truth. */

export const BUILDER_DEVICE_TAB = {
  SHARED: 'Shared / All devices',
  APPLE: 'Apple',
  GOOGLE: 'Google',
} as const;

export const BUILDER_PASS_TAB = {
  FRONT: 'Front',
  BACK: 'Back',
  FEATURES: 'Features',
} as const;

export type BuilderDeviceTab =
  (typeof BUILDER_DEVICE_TAB)[keyof typeof BUILDER_DEVICE_TAB];

export type BuilderPassTab =
  (typeof BUILDER_PASS_TAB)[keyof typeof BUILDER_PASS_TAB];

/** Platform tabs in display order (Shared → Apple → Google). */
export const BUILDER_DEVICE_TABS: BuilderDeviceTab[] = [
  BUILDER_DEVICE_TAB.SHARED,
  BUILDER_DEVICE_TAB.APPLE,
  BUILDER_DEVICE_TAB.GOOGLE,
];

/** Pass section tabs in display order (Front → Back → Features). */
export const BUILDER_PASS_TABS: BuilderPassTab[] = [
  BUILDER_PASS_TAB.FRONT,
  BUILDER_PASS_TAB.BACK,
  BUILDER_PASS_TAB.FEATURES,
];
